import { Flex, Typography } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { twMerge } from 'tailwind-merge'
import { Card } from '../Card'
import FolderImage, { type FolderVariant } from './FolderImage'

const { Title, Text } = Typography

interface MaterialCardProps {
  materialCounts: number
  additionalButtons: ReactNode
  cardOnClick: () => void
  typeLabel: ReactNode
  style?: FolderVariant
}

export const MaterialCard: React.FC<MaterialCardProps> = ({
  materialCounts,
  additionalButtons,
  cardOnClick,
  typeLabel,
  style = 'color',
}) => {
  return (
    <Card className='h-[228px] cursor-pointer' onClick={cardOnClick}>
      <Flex vertical justify='space-between' className='h-full p-6'>
        <Flex justify='space-between' align='flex-start' className='h-full'>
          <span className='relative inline-block'>
            <FolderImage variant={style} />
            {/* Folder graphic is a fixed blue, so the count stays brand blue instead of following the institution primary color */}
            <Text
              strong
              className={twMerge(
                'absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2',
                style === 'color' ? 'text-blue5' : 'text-colorTextSecondary'
              )}
            >
              {materialCounts}
            </Text>
          </span>
          {additionalButtons}
        </Flex>
        <div className='flex w-full items-end'>
          <Title level={5}>{typeLabel}</Title>
        </div>
      </Flex>
    </Card>
  )
}
